<template>
    <app-dialog
        :open="open"
        :title="$t('Auf andere Seite kopieren').toString()"
        :title-id="headlineId"
        size="sm"
        :busy="loading"
        @close="$emit('close')"
    >
                        <div v-if="loading" class="text-sm text-gray-500">
                            {{ $t('Kopieroptionen werden geladen.') }}
                        </div>

                        <div v-else-if="pages.length < 1" class="text-sm text-gray-500">
                            {{ $t('Für dieses Modul stehen aktuell keine Zielseiten mit zulässigem Slot zur Verfügung.') }}
                        </div>

                        <div v-else class="space-y-5">
                            <div>
                                <label class="stage-filter-label mb-2 block">{{ $t('Zielseite') }}</label>
                                <select
                                    :value="selectedPageId"
                                    class="stage-filter-input form-select block w-full text-sm"
                                    @change="$emit('update:selectedPageId', normalizeNullableValue($event.target.value))"
                                >
                                    <option :value="''">{{ $t('Bitte wählen') }}</option>
                                    <option v-for="page in pages" :key="page.id" :value="page.id">
                                        {{ page.name }}
                                    </option>
                                </select>
                            </div>

                            <div>
                                <label class="stage-filter-label mb-2 block">{{ $t('Zielslot') }}</label>
                                <select
                                    :value="selectedSlot"
                                    class="stage-filter-input form-select block w-full text-sm"
                                    :disabled="availableSlots.length < 1"
                                    @change="$emit('update:selectedSlot', String($event.target.value || ''))"
                                >
                                    <option :value="''">{{ $t('Bitte wählen') }}</option>
                                    <option v-for="slot in availableSlots" :key="slot.key" :value="slot.key">
                                        {{ slot.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
        <template #footer>
            <app-dialog-action
                :label="$t('Kopieren').toString()"
                :disabled="!canConfirm"
                @click="$emit('confirm')"
            />
        </template>
    </app-dialog>
</template>

<script>
import AppDialog from '@/components/modals/app-dialog.vue';
import AppDialogAction from '@/components/modals/app-dialog-action.vue';

export default {
    name: 'module-copy-to-page-dialog',
    components: {AppDialog, AppDialogAction},
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        pages: {
            type: Array,
            default: () => [],
        },
        selectedPageId: {
            type: [Number, String, null],
            default: null,
        },
        selectedSlot: {
            type: String,
            default: '',
        },
        headlineId: {
            type: String,
            default: 'module-copy-to-page-dialog-headline',
        },
    },
    emits: ['close', 'confirm', 'update:selectedPageId', 'update:selectedSlot'],
    computed: {
        selectedPage() {
            const pageId = Number.parseInt(String(this.selectedPageId ?? ''), 10);

            return this.pages.find((page) => Number(page.id) === pageId) || null;
        },
        availableSlots() {
            return Array.isArray(this.selectedPage?.slots) ? this.selectedPage.slots : [];
        },
        canConfirm() {
            return !this.loading && this.selectedPage !== null && this.selectedSlot.trim() !== '';
        },
    },
    methods: {
        normalizeNullableValue(value) {
            const normalized = String(value || '').trim();

            return normalized === '' ? null : Number.parseInt(normalized, 10);
        },
    },
};
</script>
